import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
// import { FaAngellist } from 'react-icons/fa';

import { SiUpwork } from "react-icons/si";

import "./footer.css";

const Footer = ({ setActiveNav }) => {
    return (
        <footer>
            <a href="#home" className="footer__logo">
                Vitalii Kretsul
            </a>
            <ul className="permalinks">
                <li>
                    <a href="#home" onClick={() => setActiveNav("#home")}>
                        Home
                    </a>
                </li>
                <li>
                    <a href="#about" onClick={() => setActiveNav("#about")}>
                        About
                    </a>
                </li>
                <li>
                    <a
                        href="#experience"
                        onClick={() => setActiveNav("#experience")}>
                        Skills
                    </a>
                </li>
                <li>
                    <a
                        href="#portfolio"
                        onClick={() => setActiveNav("#portfolio")}>
                        Portfolio
                    </a>
                </li>
                {/* <li>
          <a href="#testimonials">Testimonials</a>
        </li> */}
                <li>
                    <a href="#contact" onClick={() => setActiveNav("#contact")}>
                        Contact
                    </a>
                </li>
            </ul>
            <div className="footer__socials">
                <a
                    href="https://www.upwork.com/freelancers/kretsulvitalii"
                    target="_blank"
                    rel="noreferrer">
                    <SiUpwork />
                </a>
                <a
                    href="https://www.linkedin.com/in/vitalii-kretsul-442213b6/"
                    target="_blank"
                    rel="noreferrer">
                    <BsLinkedin />
                </a>
                <a
                    href="https://github.com/Kretsul-Vitaliy"
                    target="_blank"
                    rel="noreferrer">
                    <FaGithub />
                </a>

                {/* <a
          href="https://angel.co/u/vitalii-kretsul"
          target="_blank"
          rel="noreferrer"
        >
          <FaAngellist />
        </a> */}
            </div>
            <div className="footer__copyright">
                <small>&copy; ET 2023. All rights reserved.</small>
            </div>
        </footer>
    );
};

export default Footer;
